<script setup>
import { defineProps } from 'vue'

const props = defineProps({
    id: Number,
    name: String,
    image: String,
    text: String,
    link: String
})
</script>

<template>
    <a
        :href="props.link"
        target="_blank"
        class="partner-card"
    >
        <h1 class="partner-card-title">{{ props.name }}</h1>
        <div class="partner-card-image-text">
            <img :src="props.image" />
            <p>
                {{ props.text }}
            </p>
        </div>
    </a>
</template>

<style lang="scss" scoped>
.partner-card {
    display: block;
    text-decoration: none;
    color: unset;
    text-align: left;
    padding: 34px 0 56px 0;
    border-top: solid 1px #dadada;

    &:last-child {
        border-bottom: solid 1px #dadada;
    }
}

.partner-card-title {
    font-size: 28px;
    font-weight: 500;
    line-height: 36px;
    color: #0635ac;
}

.partner-card-image-text {
    margin-top: 16px;
    display: flex;
    align-items: center;
    gap: 30px;

    img {
        width: 410px;
    }

    p {
        font-size: 20px;
        font-weight: 400;
        line-height: 28px;
    }

    @media screen and (max-width: 1000px) {
        flex-direction: column;

        img {
            width: 100%;
        }

    }
}
</style>
